import { Toaster as Sonner, type ToasterProps } from 'sonner';

// Canonical shadcn Sonner wrapper — the third-party `sonner` Toaster styled to
// inherit the shadcn theme tokens (background / text / border) so toasts look
// native to the console. Mounted exactly once in `App.tsx`.
const Toaster = ({ ...props }: ToasterProps): React.JSX.Element => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
